'use strict';

import { Entity } from '../Entity';

export class Report extends Entity {
  protected _data: Record<string, any> = {};

  public hydrate(data: Record<string, any>): this {
    if (data.states && typeof data.states === 'string') {
      try {
        const parsedStates = JSON.parse(data.states);
        if (Array.isArray(parsedStates)) {
          data.states = parsedStates.join(', ');
        }
      } catch (e) {
        console.warn('Failed to parse states:', data.states);
      }
    }
    this._data = data;
    return this;
  }

  public get(key: string): any {
    return this._data[key] ?? null;
  }

  public toObject(): Record<string, any> {
    return this._data;
  }
}
